"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getLandingPageSilo = exports._getTransactionSiloVessel = exports._getTransactionSilo = exports._createTransactionSilo = exports._postLEDSiloConfig = exports._getHaulerByNo = exports._getHauler = void 0;
const axios_1 = __importDefault(require("axios"));
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const error_response_1 = require("utils/error-response");
const dataError = {
    id: '',
    contractor_id: '',
    contractor_name: '',
    created_date: new Date(),
    created_by: '',
    modified_date: new Date(),
    modified_by: '',
    ticket_no: '',
    image_penalty_evidence: '',
    gate_in: new Date(),
    gate_out: new Date(),
    main_entrance_in: new Date(),
    is_active: false,
    hopper_id: '',
    hopper_name: '',
    hauler_id: '',
    hauler_no: '',
    hauler_rfid_tag: '',
    vessel1_id: '',
    vessel1_no: 0,
    vessel2_id: '',
    vessel2_no: 0,
    driver_id: '',
    driver_name: '',
    checkpoint_id: '',
    checkpoint_name: '',
    capacity_volume1: 0,
    capacity_volume2: 0,
    total_volume: 0,
    brand_id: '',
    brand_name: '',
    brand_color: '',
    brand_code: '',
};
const _getHauler = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/hauler-rfid';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.post(url, { rfid_tag: args, type: 'silo' }, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: dataError, countData: 0 };
    }
});
exports._getHauler = _getHauler;
const _getHaulerByNo = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/hauler-no';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.post(url, { hauler_no: args, type: 'silo' }, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: dataError, countData: 0 };
    }
});
exports._getHaulerByNo = _getHaulerByNo;
const _postLEDSiloConfig = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/LEDSign';
    try {
        const { data } = yield axios_1.default.post(url, payload, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            },
        });
        return {
            isError: data.isError,
            message: data.message,
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            message: err.errorMessage,
        };
    }
});
exports._postLEDSiloConfig = _postLEDSiloConfig;
const _createTransactionSilo = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/silo';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            countData: data.countData,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, countData: 0, errorMessage: response.errorMessage, data: {
                id: '',
            } });
    }
});
exports._createTransactionSilo = _createTransactionSilo;
const _getTransactionSilo = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? (sort.length > 0 ? JSON.stringify(sort) : undefined) : undefined;
    const url = String(process.env.API_ENDPOINT) + '/transaction/silo';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getTransactionSilo = _getTransactionSilo;
const _getTransactionSiloVessel = ({ start_date, end_date, vessel_id }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/silo-vessel';
    const config = {
        params: {
            start_date, end_date, vessel_id,
            sort: JSON.stringify([{ field: 'gate_in', dir: 'desc' }])
        },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getTransactionSiloVessel = _getTransactionSiloVessel;
const _getLandingPageSilo = ({ checkpoint_id }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/user/checkpointUser/page/${checkpoint_id}`;
    const config = {
        params: { type: 'silo', skip: 0, take: 10 },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            countDataTransaction: 0,
            data: {
                DeviceData: [],
                countDataTransaction: 0,
                TransactionDataSilo: [],
                ConfigurationCheckPointData: {
                    id: '',
                    type: '',
                    brand1_id: '',
                    brand2_id: '',
                    brand3_id: '',
                    brand4_id: '',
                    brand5_id: '',
                    brand1_name: '',
                    brand2_name: '',
                    brand3_name: '',
                    brand4_name: '',
                    brand5_name: '',
                    brand1_color: '',
                    brand2_color: '',
                    brand3_color: '',
                    brand4_color: '',
                    brand5_color: '',
                    dumping_type: '',
                    checkpoint_id: '',
                    checkpoint_name: '',
                    dumping_type_id: '',
                }
            }
        };
    }
});
exports._getLandingPageSilo = _getLandingPageSilo;
